export default {
  'coupon.title': 'Coupons',
  'coupon.content': 'Coupon Content',
  'coupon.record': 'Coupon Record',
  'coupon.discount': 'Discount Coupon',
  'coupon.product': 'Product Coupon',
  'coupon.balance': 'Balance Coupon',
  'coupon.select_redeem_number': 'Select Number of Redemptions',
  'coupon.error.redeem_fail': 'Redemption Failed',
  'coupon.error.redeem_fail.not_shop': 'Redemption Failed, not a stamp for a specific store',
  'coupon.error.redeem_fail.not_shop_group':
    'Redemption Failed, not a stamp for a specific store group',
  'coupon.error.redeem_fail.shop_not_found': 'Redemption Failed, store information not found',
  'coupon.error.redeem_fail.store_not_found':
    'Redemption Failed, branch/store information not found',
  'coupon.error.redeem_fail.coupon_invalid': 'Redemption Failed, coupon is not valid',
  'coupon.error.redeem_fail.remaining_not_enough':
    'Redemption Failed, insufficient balance for this coupon',
  'coupon.applicable_store': 'Applicable Stores',
  'coupon.use_period': 'Usage Period',
  'coupon.quantity_held': 'Number of Coupons Held',
  'coupon.transfer': 'Transfer',
  'coupon.not_enabled': 'This coupon has not been activated',
  'coupon.period_is': 'This coupon’s usage period is',
  'coupon.barcode': 'Barcode',
  'coupon.guide': 'Instructions',
  'coupon.choose_redeem_quantity': 'Please select the number of redemptions',
  'coupon.empty': 'No coupons available at the moment',
  'coupon.empty.product': 'Your product coupon folder is empty',
  'coupon.empty.ticket': 'Your ticket folder is empty',
  'coupon.empty.balance': 'Your balance coupon folder is empty',
  'coupon.welcome': 'Welcome to participate in activities and receive coupons',
  'coupon.redeemable': 'Redeemable',
  'coupon.not_start': 'Not Started',
  'coupon.redeem_immediately': 'Redeem Now',
  'coupon.notification_time': 'Notification Time',
  'coupon.receive_time': 'Receive Time',
  'coupon.giver': 'Giver',
  'coupon.copy_success': 'Barcode copied successfully',
  'coupon.redeem_coupon': 'Redeem Coupon',
  'coupon.redeem_store': 'Redemption Store',
  'coupon.not_start_yet': 'This coupon has not started yet',
  'coupon.redeem_count': 'Number of Redemptions',
  'coupon.redeemed': 'Redeemed',
  'coupon.expired': 'Expired',
  'coupon.voided': 'Voided',
  'coupon.receive': 'Receive Gift',
  'coupon.balance_amount': 'Balance',
  'coupon.using': 'In Use',
  'coupon.not_used': 'Not Used',
  'coupon.use_record': 'Usage Record',
  'coupon.use_amount': 'Amount Used',
  'coupon.use_time': 'Usage Time',
  'coupon.use_store': 'Store Used',
  'coupon.ticket_serial_number': 'Coupon Serial Number',
  'coupon.remaining_amount': 'Remaining Balance',
  'coupon.enter_use_amount': 'Please enter the usage amount',
  'coupon.cancel_transfer_success': 'Transfer cancellation successful',
  'coupon.cancel_transfer_fail': 'Transfer cancellation failed',
  'coupon.obtain_time': 'Obtained Time',
  'coupon.gift': 'Gift',
  'coupon.issuer': 'Issuer',
  'coupon.redeem_time': 'Redemption Time',
  'coupon.redeem_status': 'Redemption Status',
  'coupon.redeem_no': 'Redemption Number',
  'coupon.disable_time': 'Expiration Time',
  'coupon.account_status': 'Account Status',
  'coupon.overdue_time': 'Overdue Time',
  'coupon.cancel_transfer': 'Cancel Transfer',
  'coupon.count_number': 'Number of Coupons',
  'coupon.used_amount': 'Used Amount',
  'coupon.recent_use_time': 'Recent Usage Time',
  'coupon.recent_use_store': 'Most Recent Usage Store',
  'coupon.waiting': 'Processing, please wait...',
  'coupon.byurl.collect_message': 'Are you sure you want to claim {name}?',
  'coupon.byurl.confirm': 'Confirm',
  'coupon.byurl.cancel': 'Cancel',
  'coupon.byurl.OK': 'Got it',
  'coupon.byurl.already_message': 'You have already claimed the coupon!',
} as Record<string, string>;
